// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DateOfBirthFormProvider-module-datesInputWrapper-132ff{display:flex;flex-direction:column;width:100%;gap:var(--des-dimension-gap-and-padding-field-between-label-and-box)}", ""]);
// Exports
exports.locals = {
	"datesInputWrapper": "DateOfBirthFormProvider-module-datesInputWrapper-132ff"
};
module.exports = exports;
